/* global axios */

import ApiClient from './ApiClient';

class Agents extends ApiClient {
  constructor() {
    super('agents', { accountScoped: true });
  }

  bulkInvite({ emails }) {
    return axios.post(`${this.url}/bulk_create`, {
      emails,
    });
  }

  getPage({ page = 1, perPage = 100, query = '' } = {}) {
    return axios.get(this.url, {
      params: { page, per_page: perPage, query },
    });
  }

  listConversations(agentId, { filter } = {}) {
    return axios.get(`${this.url}/${agentId}/conversations`, {
      params: { filter },
    });
  }

  hubUserData(agentId) {
    return axios.get(`${this.url}/${agentId}/hub_user_data`);
  }
}

export default new Agents();
